import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useConfig } from '../../../context';
import { useRenderers } from '../../../renderProps';
import { Tooltip } from '../../../BaseComponents';
import { CdnIcon } from '@shared/ui';
import { isExistI18nTranslate } from '../../../utils';
import { SafeHtml } from '@shared/ui';
const DescriptionBlock = ({ description, title, showConfirmedIcon, variant, isOld, isDisabled }) => {
    var _a;
    const { t, i18n } = useTranslation('FareLock');
    const { DescriptionBlock: css } = useTheme('FareLock');
    const { global: { companyInfo } } = useConfig();
    const { getConfirmOptionIcon } = useRenderers();
    const existWarningDescription = i18n.exists('WarningDescription', { ns: 'FareLock' });
    const getIcon = () => {
        switch (variant) {
            case 'FareLock':
                return isOld ? 'Confirm/Lock Price' : 'Info/Lock';
            case 'Refund':
                return isOld ? 'Confirm/Refund' : 'Services/Refundable';
            case 'Upgrade':
                return isOld ? 'Confirm/Add Flex' : 'Arrow/Upward';
            case 'Note':
                return isOld ? 'Confirm/Credit' : 'Info/Lock';
            default:
                return null;
        }
    };
    const renderDetails = ({ link, action, text, title }) => {
        return link ? (React.createElement("a", { href: link !== null && link !== void 0 ? link : '#', onClick: event => {
                if (action) {
                    event.preventDefault();
                    action();
                }
            }, className: css.rules, target: "_blank" },
            React.createElement(CdnIcon, { icon: "Info/Details" }),
            React.createElement(SafeHtml, { tag: "span", html: text }))) : (title && (React.createElement(Tooltip, { title: title, disableFocusListener: isDisabled, disableHoverListener: isDisabled },
            React.createElement("span", { className: css.rules },
                React.createElement(CdnIcon, { icon: "Info/Details" }),
                " ",
                text))));
    };
    const renderFareLock = () => {
        return existWarningDescription ? (React.createElement(SafeHtml, { tag: "div", className: css.warning, html: t('WarningDescription') })) : (companyInfo.farelockURL &&
            isExistI18nTranslate('Rules of service provision', { ns: 'FareLock' }) &&
            renderDetails({
                link: companyInfo.farelockURL,
                text: t('Rules of service provision')
            }));
    };
    const icon = getIcon();
    return (React.createElement("div", { className: cn(css.root, {
            [css.root_old]: isOld,
            [css.root_disabled]: isDisabled,
            [css.root_refund]: variant === 'Refund',
            [css.root_fareLock]: variant === 'FareLock',
            [css.root_upgrade]: variant === 'Upgrade',
            [css.root_note]: variant === 'Note'
        }) },
        icon && (React.createElement("div", { className: css.iconWrapper },
            React.createElement(CdnIcon, { className: css.icon, icon: (_a = getConfirmOptionIcon === null || getConfirmOptionIcon === void 0 ? void 0 : getConfirmOptionIcon({ variant })) !== null && _a !== void 0 ? _a : getIcon() }))),
        React.createElement("div", { className: css.info },
            React.createElement("div", { className: css.title },
                showConfirmedIcon && React.createElement(CdnIcon, { className: css.confirmedIcon, icon: "Info/Choosed" }),
                title),
            React.createElement("div", { className: css.description },
                React.createElement("div", { className: css.description__text }, description),
                variant === 'FareLock' && renderFareLock(),
                variant === 'Refund' &&
                    renderDetails({
                        text: t('Additional information'),
                        title: t('The cost of the refund service will be added to the fare and fees. The total amount will increase by the specified cost.')
                    }),
                variant === 'Upgrade' &&
                    companyInfo.upgradeOptionURL &&
                    renderDetails({
                        link: companyInfo.upgradeOptionURL,
                        text: t('UpgradeFlightClass:More details')
                    })))));
};
export default DescriptionBlock;
